// extracted by mini-css-extract-plugin
export default {"mainContainer":"Z_jp"};